interface BreadcrumbItem {
  name: string;
  path: string;
}

interface SEOSchemaProps {
  pageType: 'homepage' | 'category' | 'article' | 'about';
  pageTitle: string;
  pageDescription?: string;
  canonicalPath: string;
  breadcrumbs?: BreadcrumbItem[];
  articleData?: {
    title: string;
    author: string;
    datePublished: string;
    dateModified?: string;
    category?: string;
  };
  faqData?: Array<{ question: string; answer: string }>;
}

export default function SEOSchema({
  pageType,
  pageTitle,
  pageDescription,
  canonicalPath,
  breadcrumbs,
  articleData,
  faqData,
}: SEOSchemaProps) {
  const baseUrl = 'https://nohandcode.github.io';
  const schemas: any[] = [];

  schemas.push({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${baseUrl}/#website`,
    url: baseUrl,
    name: '无码',
    alternateName: '无码开发平台',
    description: '无码是新一代低代码/无码开发平台，帮助企业和个人无需编写代码即可快速搭建应用、自动化流程与数字化系统。',
    inLanguage: 'zh-CN',
  });

  schemas.push({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${baseUrl}/#organization`,
    name: '无码',
    url: baseUrl,
    description: '新一代低代码/无码开发平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9999',
      contactType: 'customer service',
      email: 'contact@wuma.io',
      availableLanguage: 'Chinese',
    },
    sameAs: [],
  });

  if (pageType === 'homepage') {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${baseUrl}${canonicalPath}/#webpage`,
      url: `${baseUrl}${canonicalPath}`,
      name: pageTitle,
      description: pageDescription,
      isPartOf: { '@id': `${baseUrl}/#website` },
      about: { '@id': `${baseUrl}/#organization` },
      inLanguage: 'zh-CN',
    });
  } else {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${baseUrl}${canonicalPath}/#webpage`,
      url: `${baseUrl}${canonicalPath}`,
      name: pageTitle,
      description: pageDescription,
      isPartOf: { '@id': `${baseUrl}/#website` },
      about: { '@id': `${baseUrl}/#organization` },
      inLanguage: 'zh-CN',
    });

    if (breadcrumbs && breadcrumbs.length > 0) {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((item, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: item.name,
          item: `${baseUrl}${item.path}`,
        })),
      });
    }
  }

  if (pageType === 'article' && articleData) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'Article',
      '@id': `${baseUrl}${canonicalPath}/#article`,
      headline: articleData.title,
      author: {
        '@type': 'Person',
        name: articleData.author,
      },
      datePublished: articleData.datePublished,
      dateModified: articleData.dateModified || articleData.datePublished,
      isPartOf: { '@id': `${baseUrl}${canonicalPath}/#webpage` },
      inLanguage: 'zh-CN',
    });
  }

  if (faqData && faqData.length > 0) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqData.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    });
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }}
    />
  );
}